import {iconProfile} from '@shared/helpers/icons'
import {DropdownDivider} from 'swayok-react-mdb-ui-kit/components/Dropdown/DropdownDivider'
import {DropdownItem} from 'swayok-react-mdb-ui-kit/components/Dropdown/DropdownItem'
import {Icon} from 'swayok-react-mdb-ui-kit/components/Icon/Icon'
import {RatingStars} from 'swayok-react-mdb-ui-kit/components/Icon/RatingStars'
import {appUrl} from '../../../AppUrl'
import {UserAvatar} from '../../../components/UserAvatar'
import {trans} from '../../../helpers'
import {useUserData} from '../../../hooks'
import {useAuthStore} from '../../../stores'
import {CabinetUserReviewsButton} from '../../private/shared/cabinet_menu/CabinetUserReviewsButton'

// Данные профиля пользователя в выпадающем меню в заголовке страницы.
export function TopNavigationUserDropdownMenuUserInfo() {

    const user = useUserData()

    const initUserAuthModal = useAuthStore(
        state => state.initUserAuthModal
    )

    if (!user) {
        // Todo: add block for guest user
        return (
            <>
                <DropdownItem
                    href={appUrl().auth.login}
                    className="with-icon-flex gap-2"
                    onClick={e => {
                        e.preventDefault()
                        initUserAuthModal()
                    }}
                >
                    <Icon
                        path={iconProfile}
                    />
                    {trans().common.top_navigation.cabinet}
                </DropdownItem>
                <DropdownDivider />
            </>
        )
    }

    return (
        <>
            <div className="px-3 pb-2 d-flex gap-3 flex-row align-items-center">
                <UserAvatar userName={user.fullName} />
                <div className="d-flex flex-column align-items-stretch">
                    <div className="fw-500">
                        {user.fullName}
                    </div>
                    <div
                        className="flex-container-row gap-2 my-1"
                        title={String(user.rating)}
                    >
                        <RatingStars
                            rating={user.rating}
                            starSize={20}
                        />
                    </div>
                    <CabinetUserReviewsButton />
                </div>
            </div>
            <DropdownDivider />
        </>
    )
}
